import React from "react";
import { Field, FieldProps } from "formik";
import { TextField, Grid } from "@mui/material";

const RequiredFields = () => {

  const formatPhoneNumber = (value: string) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
  
    if (phoneNumberLength <= 3) return `(${phoneNumber}`;
  
    if (phoneNumberLength <= 6) {
      return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3)}`;
    }
  
    return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };
  
  
  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} sm={12} md={6}>
        <Field name="firstName">
          {({ field, form: { setFieldValue }, meta }: FieldProps) => (
            <TextField
              id="firstName"
              label="Your First Name *"
              placeholder="Your First Name"
              {...field}
              onChange={(event) => setFieldValue(field.name, event.target.value)}
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error ? meta.error : ""}
              fullWidth
            />
          )}
        </Field>
      </Grid>

      <Grid item xs={12} sm={12} md={6}>
        <Field name="lastName">
          {({ field, form: { setFieldValue }, meta }: FieldProps) => (
            <TextField
              id="lastName"
              label="Your Last Name *"
              placeholder="Your Last Name"
              {...field}
              onChange={(event) => setFieldValue(field.name, event.target.value)}
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error ? meta.error : ""}
              fullWidth
            />
          )}
        </Field>
      </Grid>

      <Grid item xs={12}>
        <Field name="email">
          {({ field, form: { setFieldValue }, meta }: FieldProps) => (
            <TextField
              id="email"
              label="Your Email Address *"
              placeholder="Your Email Address"
              {...field}
              onChange={(event) => setFieldValue(field.name, event.target.value)}
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error ? meta.error : ""}
              fullWidth
            />
          )}
        </Field>
      </Grid>

      <Grid item xs={12}>
        <Field name="phone_number">
          {({ field, form: { setFieldValue }, meta }: FieldProps) => (
            <TextField
              id="phone_number"
              label="Your Phone Number *"
              placeholder="Your Phone Number"
              {...field}
              value={formatPhoneNumber(field.value)}
              onChange={(event) => setFieldValue(field.name, formatPhoneNumber(event.target.value))}
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error ? meta.error : ""}
              fullWidth
            />
          )}
        </Field>
      </Grid>
    </Grid>
  );
};

export default RequiredFields;
